import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tvshows';

const allShows = tvShows.sort((a, b) => b.year - a.year).slice(0, 12);

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50" aria-label="最新更新">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">持续更新中，精彩不间断</p>
          </div>
          <Link
            to="/category/guochan"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            全部剧集
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {allShows.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2.5">
                <img
                  src={show.posterImage}
                  alt={show.title}
                  title={`${show.title} - 久播影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] text-background-50/90 bg-black/40 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {show.episodes}集
                    </span>
                    <span className="text-[10px] text-background-50/90 bg-black/40 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {show.status}
                    </span>
                  </div>
                </div>
                {show.new && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] bg-accent-500 text-background-50 rounded whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {show.title}
              </h3>
              <div className="flex items-center gap-1 mt-0.5">
                <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                <span className="text-xs text-foreground-500">{show.rating}</span>
                <span className="text-xs text-foreground-400 ml-1">{show.year}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}